export enum PharmacyDiagnosisType {
    Initial = 1,
    Final = 2,
}